export default function PriceComparisonSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            でも、HP制作は高すぎる…
          </h2>
        </div>

        {/* Comparison Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* General Market Price */}
          <div className="bg-slate-100 rounded-2xl p-8 border-2 border-slate-300">
            <h3 className="text-2xl font-bold text-slate-800 mb-6 text-center">
              一般的な相場
            </h3>
            <div className="space-y-6">
              <div className="bg-white rounded-xl p-6">
                <p className="text-lg font-semibold text-slate-700 mb-2">制作会社</p>
                <p className="text-slate-600">初期 <strong className="text-2xl text-slate-800">30〜80万円</strong></p>
                <p className="text-slate-600">月額 <strong className="text-xl text-slate-800">1〜2万円</strong></p>
              </div>
              <div className="bg-white rounded-xl p-6">
                <p className="text-lg font-semibold text-slate-700 mb-2">フリーランス</p>
                <p className="text-slate-600">初期 <strong className="text-2xl text-slate-800">10〜30万円</strong></p>
                <p className="text-slate-600">月額 <strong className="text-xl text-slate-800">5,000〜1万円</strong></p>
              </div>
            </div>
          </div>

          {/* Our Price */}
          <div className="bg-gradient-to-br from-cyan-600 to-cyan-700 rounded-2xl p-8 border-4 border-amber-500 shadow-2xl relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-amber-500 text-white px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap">
              圧倒的コスパ！
            </div>
            <h3 className="text-2xl font-bold text-white mb-6 text-center">
              サクッとHP
            </h3>
            <div className="space-y-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border-2 border-white/30">
                <p className="text-lg font-semibold text-cyan-100 mb-2">初期費用</p>
                <p className="text-6xl font-bold text-white">¥0</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border-2 border-white/30">
                <p className="text-lg font-semibold text-cyan-100 mb-2">月額</p>
                <p className="text-6xl font-bold text-amber-400">¥4,980</p>
                <div className="mt-3 bg-amber-400/20 border border-amber-400/50 rounded-lg px-4 py-2 inline-block">
                  <p className="text-amber-300 text-sm font-semibold">
                    🎉 モニター価格 <span className="text-xl font-bold text-white">¥3,980</span> / 月
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="text-center">
          <p className="text-xl text-slate-700 leading-relaxed">
            「HPは欲しいけど、費用がネックで…」<br />
            <strong className="text-cyan-600">そんな方のためのサービスです。</strong>
          </p>
        </div>
      </div>
    </section>
  );
}